import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

const MechanicsRecordObservations = () => {
  return (
    <table style={{ marginTop: 12 }}>
      <thead>
        <tr>
          <th>Observações</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            <TextArea rows={10} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default MechanicsRecordObservations;
